import { KeyboardEvent, SetStateAction } from "react";
import { stdObject } from "../../../data/types/stdObject";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { colors } from "../../../data/colors";
import convertDate from "../../../utils/convertDate";
import { initBatchesDocCodes, itemsAutoStock } from "../../../data/main";
import { arrangeBatches } from "../../../utils/arrangeBatches";

const updateItemSerie = ({
  index,
  status,
  value = "",
  packUpdateBatch,
  closeMsg,
}: {
  index: number;
  status: string;
  value?: any;
  packUpdateBatch: stdObject;
  closeMsg: (e: number) => void;
}) => {
  const {
    t,
    modalData,
    windowValues,
    setMsg2,
    setModalData2,
    setWindowValues,
  } = packUpdateBatch;
  let tempWindow = { ...windowValues };
  let returnData = false;
  switch (status) {
    case "quantity":
      tempWindow.table[index].data.CANBA0 = Math.trunc(Number(value));
      tempWindow.total = tempWindow.table.reduce(
        (acc: number, curr: stdObject) => (acc += curr.data.CANBA0),
        0,
      );
      const notQuantity = tempWindow.table[index].data.CANBA0 < 1;
      const batchAvailable = modalData.available.find(
        (e: stdObject) => e.IDBA1 === tempWindow.table[index].data.IDBA0,
      ).CANBA1;
      const batchOver = tempWindow.table[index].data.CANBA0 > batchAvailable;

      if (tempWindow.total > modalData.quantity || batchOver || notQuantity) {
        const globalTotal =
          tempWindow.table[index].data.CANBA0 -
          (tempWindow.total - modalData.quantity);
        setMsg2("custom2");
        setModalData2({
          code: "warning",
          title: notQuantity
            ? t("p.addCorrectAmount")
            : t("p.quantityExceeded"),
          buttons: [
            {
              label: t("p.close"),
              onClick: () => closeMsg(2),
            },
          ],
        });
        tempWindow.table[index].data.CANBA0 = notQuantity
          ? 1
          : batchAvailable > globalTotal
            ? globalTotal
            : batchAvailable;
        tempWindow.total = modalData.quantity;
      }
      break;
    // case "date":
    //   tempWindow.table[index].data.EXPBAT = value;
    //   break;
    case "delete":
      tempWindow.table.splice(index, 1);
      tempWindow.total = tempWindow.table.reduce(
        (acc: number, curr: stdObject) => (acc += curr.data.CANBA0),
        0,
      );
      break;
  }

  setWindowValues(returnData ? { ...windowValues } : tempWindow);
};

const validInputValue = (
  e: KeyboardEvent<HTMLInputElement> | { key: string },
  type: string,
  batches: Array<stdObject>,
  packUpdateBatch: stdObject,
  closeMsg: (e: number) => void,
) => {
  const { t, modalData, windowValues, setWindowValues } = packUpdateBatch;
  if (e.key === "Enter" && windowValues.search.trim() !== "") {
    const quantity = windowValues.quantity;
    let validBlocked: stdObject = [
      { status: false, msg: "p.addCorrectAmount" },
      { status: false, msg: "p.quantityExceeded" },
      { status: false, msg: "p.serialCodeAlreadyExists" },
      { status: false, msg: "p.serialCodeAlreadyExists" },
      { status: false, msg: "p.serialCodeNotAvailable" },
    ];

    for (let a = 0; a < validBlocked.length; a++) {
      switch (a) {
        case 0:
          validBlocked[a].status = quantity < 1;
          break;
        case 1:
          validBlocked[a].status =
            windowValues.table.reduce(
              (acc: number, curr: stdObject) => (acc += curr.data.CANBA0),
              0,
            ) +
              quantity >
              modalData.quantity && !modalData.openQty;
          break;
        case 2:
          validBlocked[a].status = windowValues.table.some(
            (v: stdObject) =>
              v.data.IDBA0.toLowerCase() ===
                windowValues.search.trim().toLowerCase() ||
              (modalData.type === 4 &&
                v.data.EXPBAT === windowValues.search.trim()),
          );
          break;
        case 3:
          /*validBlocked[a].status = Object.keys(batches)
            .filter((v: string) => Number(v) !== modalData.line)
            .some((v: string) => {
              return batches[Number(v)].some(
                (o: stdObject) =>
                  o.ARTBA0 === modalData.item &&
                  (o.IDBA0.toLowerCase() ===
                    windowValues.search.trim().toLowerCase() ||
                    (modalData.type === 4 && o.EXPBAT === windowValues.search)),
              );
            });*/
          break;
        default:
          if (!initBatchesDocCodes.includes(type)) {
            const itemAvaliable = modalData.available.filter(
              (v: stdObject) =>
                v.IDBA1.toLowerCase() ===
                  windowValues.search.trim().toLowerCase() ||
                (modalData.type === 4 &&
                  v.IDBA1.endsWith("-" + windowValues.search)),
            );
            console.log("itemAvaliable", itemAvaliable);
            validBlocked[a].status =
              itemAvaliable.length === 0 || itemAvaliable[0].CANBA1 < quantity;

            if (itemAvaliable.length > 0) {
              if (!validBlocked[a].status) {
                windowValues.search = itemAvaliable[0].IDBA1;
              } else if (modalData.type === 4) {
                validBlocked[a].msg = "p.expirationDateNotAvailable";
              } else if (itemAvaliable[0].CANBA1 < quantity) {
                validBlocked[a].msg = "p.quantityExceeded";
              }
            }
          }
          break;
      }

      if (validBlocked[a].status) {
        break;
      }
    }

    console.log("validBlocked", validBlocked);

    if (validBlocked.some((v: stdObject) => v.status)) {
      msgExceedsQuantity(
        t(validBlocked.find((v: stdObject) => v.status).msg),
        packUpdateBatch,
        closeMsg,
      );
    } else {
      let tempWindow = windowValues;

      tempWindow.table.unshift({
        data: {
          IDBA0:
            modalData.type === 4 && initBatchesDocCodes.includes(type)
              ? ""
              : windowValues.search.trim(),
          CANBA0: quantity,
          EXPBAT:
            modalData.type === 4
              ? initBatchesDocCodes.includes(type)
                ? windowValues.search
                : windowValues.search.slice(-10)
              : "",
        },
        records: [],
        info: false,
      });
      setWindowValues({
        search:
          modalData.type === 4 &&
          modalData.available.length > 0 &&
          !initBatchesDocCodes.includes(type)
            ? modalData.available[0].IDBA1
            : "",
        quantity: 1,
        table: tempWindow.table,
        total: tempWindow.table.reduce(
          (acc: number, curr: stdObject) => (acc += curr.data.CANBA0),
          0,
        ),
      });
    }
  }
};

const msgExceedsQuantity = (
  title: string,
  packUpdateBatch: stdObject,
  closeMsg: (e: number) => void,
) => {
  const { t, setMsg2, setModalData2 } = packUpdateBatch;
  setMsg2("custom2");
  setModalData2({
    code: "warning",
    title,
    buttons: [
      {
        label: t("p.close"),
        onClick: () => closeMsg(2),
      },
    ],
  });
};

export const getBatchesInputType = ({
  index,
  e,
  packUpdateBatch,
  closeMsg,
}: {
  index: number;
  e: stdObject;
  packUpdateBatch: stdObject;
  closeMsg: (e: number) => void;
}) => {
  const { t, modalData } = packUpdateBatch;
  return {
    data: [
      [3, 4].includes(modalData.type) || e.data?.CANBA0 > 1
        ? {
            type: "number",
            value: e.data.CANBA0,
            style: { width: 80 },
            innerStyle: { textAlign: "right" },
            onChange: (e: { target: { value: SetStateAction<string> } }) =>
              updateItemSerie({
                index,
                status: "quantity",
                value: e.target.value,
                packUpdateBatch,
                closeMsg,
              }),
          }
        : null,
      [0, 1, 2, 3].includes(modalData.type) ? e.data?.IDBA0 : null,
      modalData.type === 4
        ? convertDate({ info: e.data.EXPBAT, full: true, time: false, t })
        : null,
      {
        type: "icon",
        Icon: DeleteForeverIcon,
        color: colors.red,
        style: { width: 10 },
        onClick: () =>
          updateItemSerie({
            index,
            status: "delete",
            packUpdateBatch,
            closeMsg,
          }),
      },
    ],
  };
};

export const batchesMainInput = (
  type: string,
  batches: stdObject[],
  packUpdateBatch: stdObject,
  closeMsg: (e: number) => void,
) => {
  const { t, user, modalData, windowValues, setWindowValues } = packUpdateBatch;
  return [
    modalData.type !== 2
      ? {
          label: t("p.quantity"),
          value: windowValues.quantity ?? "",
          type: "number",
          style: { width: 50 },
          onChange: (e: { target: { value: SetStateAction<string> } }) => {
            setWindowValues({
              ...windowValues,
              total: itemsAutoStock.includes(modalData.type)
                ? Number(e.target.value)
                : windowValues.total,
              quantity: Number(e.target.value),
            });
          },
          onKeyDown: itemsAutoStock.includes(modalData.type)
            ? () => {}
            : (e: KeyboardEvent<HTMLInputElement> | { key: string }) =>
                validInputValue(e, type, batches, packUpdateBatch, closeMsg),
        }
      : null,
    [2, 3, 4].includes(modalData.type)
      ? {
          label: [2, 3].includes(modalData.type)
            ? t("p.serialCode")
            : t("p.expirationDate"),
          value: windowValues.search ?? "",
          type: initBatchesDocCodes.includes(type)
            ? modalData.type === 4 // [2, 3].includes(modalData.type) // && [1].includes(user.STOROL)
              ? "date"
              : "text"
            : "select",
          options:
            modalData.available.length > 0
              ? modalData.available.map((e: stdObject) => {
                  return {
                    label:
                      (modalData.type === 4
                        ? convertDate({
                            info: e.EXPBAT,
                            full: true,
                            time: false,
                            t,
                          })
                        : e.IDBA1) + ` [${e.CANBA1}] `,
                    value: e.IDBA1,
                  };
                })
              : [],
          style: { width: [2, 3].includes(modalData.type) ? null : 120 },
          maxLength: 40,
          onChange: (e: { target: { value: SetStateAction<string> } }) =>
            setWindowValues({ ...windowValues, search: e.target.value }),
          onKeyDown: (e: KeyboardEvent<HTMLInputElement> | { key: string }) =>
            validInputValue(e, type, batches, packUpdateBatch, closeMsg),
        }
      : null,
    [2, 3, 4].includes(modalData.type)
      ? {
          label: t("p.add"),
          type: "button",
          color: colors.orange,
          inputStyle: {
            justifyItems: "center",
            paddingTop: 5,
            paddingBottom: 5,
          },
          onClick: () =>
            validInputValue(
              { key: "Enter" },
              type,
              batches,
              packUpdateBatch,
              closeMsg,
            ),
        }
      : null,
  ];
};

export const updateBatches = (
  docValues: stdObject,
  packUpdateBatch: stdObject,
  closeMsg: () => void,
) => {
  const {
    t,
    user,
    modalData,
    setModalData,
    windowValues,
    setDocValues,
    setWindowValues,
  } = packUpdateBatch;
  let tempDocValues = docValues;
  console.log("windowValues.table", windowValues.table);
  if (itemsAutoStock.includes(modalData.type) && !modalData.openQty) {
    if (windowValues.quantity > modalData.quantity) {
      msgExceedsQuantity(t("p.quantityExceeded"), packUpdateBatch, closeMsg);
      return;
    }
  } else {
    if (modalData.openQty) {
      tempDocValues.items[modalData.index][`CAN${docValues.itemType}`] =
        windowValues.total;
    }
    if (!modalData.serie2) {
      tempDocValues.items[modalData.index].BATCHES = [];
    }

    if (windowValues.table.length === 0) {
      tempDocValues.batches[modalData.line] = [];
      if (modalData.serie2) {
        tempDocValues.items[modalData.index].BATCHES = tempDocValues.items[
          modalData.index
        ].BATCHES.map((e: stdObject) => {
          delete e.TRABA0;
          return e;
        });
      }
    } else {
      const { batchesTable, batchesBox } = arrangeBatches({
        data: modalData,
        table: windowValues.table,
        batchesBox: tempDocValues.items[modalData.index].BATCHES,
      });
      console.log({ batchesTable, batchesBox });
      tempDocValues.batches[modalData.line] = batchesTable;
      tempDocValues.items[modalData.index].BATCHES = batchesBox;
    }
  }

  setModalData({});
  setWindowValues({});
  closeMsg();

  const pendCode = modalData.serie2
    ? `PEN2${docValues.itemType}`
    : `PEN${docValues.itemType}`;

  const tempQuantity = [0, 1].includes(modalData.type)
    ? windowValues.quantity
    : windowValues.table.reduce(
        (acc: number, curr: stdObject) => (acc += curr.data.CANBA0),
        0,
      );

  tempDocValues.items[modalData.index][pendCode] = tempQuantity;

  if (
    tempDocValues.type === "TRA" &&
    !tempDocValues.isTransferIn &&
    user.TRAROL
  ) {
    tempDocValues.items[modalData.index][`PEN2${docValues.itemType}`] =
      tempQuantity;
  }

  setDocValues({ ...tempDocValues });
};
